import template from './cadastral-building-number.jade';
import houseType from '../../../enums/type-house';
import validation from './../../../services/validation';

export default angular
  .module('cian.addForm.cadastralBuildingNumber', [])
  .directive('cianAfAboutObjectCadastralBuildingNumber', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'deviceService',
      'popupService',
      function (deviceService, popupService) {
        'ngInject';
        this.typeOptions = houseType;
        this.validation = validation(this.form, 'cadastralBuildingNumber');
        this.isMobile = deviceService.isMobile;
        this.validation = validation(this.form, 'cadastralNumber', {
          maxlength: 'Допустимо не более 30 символов',
        });
        const modalHintTitle = 'Кадастровый номер';
        const tooltipText = 'Номер в формате 47:14:1203001:814.<br />Указан в Свидетельстве о собственности.';

        this.openTooltipModal = () => {
          popupService.openPopup('hint', {
            text: tooltipText,
            title: modalHintTitle,
            hideCloseButton: false,
          });
        };
      },
    ],
    controllerAs: 'cadastralBuildingNumber',
    template,
  })).name;
